

































import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { UserIcon } from 'tdesign-icons-vue';
import '@/renderer/assets/images/Icon/svg/personal.svg';
import '@/renderer/assets/images/Icon/svg/personal-en.svg';
import '@/renderer/assets/images/Icon/svg/team.svg';
import '@/renderer/assets/images/Icon/svg/team-en.svg';
import '@/renderer/assets/images/Icon/svg/enterprise.svg';
import '@/renderer/assets/images/Icon/svg/enterprise-en.svg';
import '@/renderer/assets/images/Icon/svg/org-channel-tag.svg';
import '@/renderer/assets/images/Icon/svg/org-channel-tag-en.svg';
import '@/renderer/assets/images/Icon/svg/temporary.svg';
import '@/renderer/assets/images/Icon/svg/temporary-en.svg';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
export default defineComponent({
  name: 'UserLogo',
  components: {
    UserIcon,
    BaseIcon,
  },
  props: {
    //  简单格式（简单化不展示企业信息）只有头像
    simple: {
      required: false,
      default: false,
      type: Boolean,
    },
    //  用户描述信息，需要同时传递nickName和userId
    // example {nickName:'王超',userId:299}
    userBaseInfo: {
      required: false,
      type: Object as () => {
        avatar: string;
        nickName: string;
        accountId: number;
      },
    },
  },
  setup(props, context) {
    const store = context.root.$store as any;
    const { userBaseInfo } = toRefs(props);
    //  用户头像
    const userAvatarImage = computed(() => {
      if (userBaseInfo?.value && 'avatar' in userBaseInfo?.value) {
        if (userBaseInfo?.value?.avatar) {
          return userBaseInfo.value?.avatar.includes('http')
            ? userBaseInfo.value?.avatar
            : `${store.getters.protocol}:${userBaseInfo.value?.avatar}`;
        }
        return '';
      }
      const { avatar } = store.getters.userBaseInfo;
      if (!avatar) return '';
      return avatar.includes('http') ? avatar : `${store.getters.protocol}:${avatar}`;
    });
    //  用户昵称
    const userNickname = computed(() => {
      if (userBaseInfo?.value && 'nickName' in userBaseInfo?.value) return userBaseInfo.value?.nickName;
      return store.getters.userBaseInfo.nickname;
    });
    // 用户账号ID
    const userAccountId = computed(() => {
      if (userBaseInfo?.value && 'accountId' in userBaseInfo.value) return userBaseInfo.value?.accountId;
      return store.getters.userId;
    });
    // 是否临时用户
    const isTemporary = computed(() => store.getters.userBaseInfo.isTemporary);
    //  是否个人
    const isPersonal = computed(() => store.getters.editionFlag === 'personal');
    //  是否团队
    const isTeam = computed(() => store.getters.editionFlag === 'team');
    //  是否渠道体验版
    const isChannel = computed(() => store.getters.orgChannel && !store.getters.channelUpdated);
    return {
      isTemporary,
      isTeam,
      isPersonal,
      isChannel,
      userAvatarImage,
      userNickname,
      userAccountId,
    };
  },
});
